// Deserializa un JWT y retorna el payload como objeto
export function decodeJWT(token: string): Record<string, any> | null {
  if (!token) return null;
  try {
    // 1. Separar el token por los puntos
    const parts = token.split(".");
    if (parts.length !== 3) return null;
    // 2. El payload es la segunda parte
    const payload = parts[1];
    // 3. Base64url decode (reemplazar - y _)
    const base64 = payload.replace(/-/g, "+").replace(/_/g, "/");
    // 4. Agregar padding si es necesario
    const padded = base64.padEnd(
      base64.length + ((4 - (base64.length % 4)) % 4),
      "="
    );
    // 5. Decodificar base64
    const decoded = atob(padded);
    // 6. Parsear JSON
    return JSON.parse(decoded);
  } catch {
    return null;
  }
}
